import { Flex, Skeleton } from '@percent/lemonade'

export function SwitchToGlobalResultsSkeleton() {
  return (
    <Flex justify="flex-start" align="center" wrap="nowrap" gap="xs">
      <Skeleton variant="rectangular" width={120} height={20} />
      <Skeleton variant="rectangular" width={24} height={24} style={{ borderRadius: '50%' }} />
      <Skeleton variant="rectangular" width={80} height={20} />
      <Flex align="center" gap="xs">
        <Skeleton variant="rectangular" width={60} height={20} />
        <Skeleton variant="rectangular" width={100} height={28} style={{ borderRadius: 16 }} />
      </Flex>
    </Flex>
  )
}
